module.exports = __webpack_public_path__ + "static/media/aidanResume.8d390fc3.pdf";